import de from './de.json';
import en from './en.json';
import th from './th.json';

const translations = { de, en, th };

export default translations;

export const getTranslation = (lang, key) => {
  const keys = key.split('.');
  let value = translations[lang] || translations.de;
  
  for (const k of keys) {
    if (value && value[k]) {
      value = value[k];
    } else {
      // Fallback to German
      value = translations.de;
      for (const fallbackKey of keys) {
        if (value && value[fallbackKey]) {
          value = value[fallbackKey];
        } else {
          return key;
        }
      }
      break;
    }
  }
  
  return value;
};
